module.exports = "/dist/7d77e1f03eefc452dab14d7f89080083.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700.woff2
// module id = 133
// module chunks = 0